import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: false,
    success: false,
    error: null,
    hasSubscription: false,
    hasUsedFreeTrial: false,
    subscriptionChecked: false,
  },
  reducers: {
    updatePasswordRequest: (state) => {
      state.loading = true;
      state.success = false;
      state.error = null;
    },
    updatePasswordSuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    updatePasswordFail: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // Resets the password-form flags only (see UpdatePassword). Subscription
    // fields are intentionally left untouched: clearing them here would flash
    // the unsubscribed UI at a subscribed user. Logout needs no reset either,
    // since every sign-in is a hard navigation that rebuilds this store.
    resetUserState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
    },
    setValidateSubscription: (state, action) => {
      state.hasSubscription = action.payload;
      state.subscriptionChecked = true;
    },
    setSubscriptionChecked: (state) => {
      state.subscriptionChecked = true;
    },
    setHasUsedFreeTrial: (state, action) => {
      state.hasUsedFreeTrial = action.payload;
    },
  },
});

export const {
  updatePasswordRequest,
  updatePasswordSuccess,
  updatePasswordFail,
  resetUserState,
  setValidateSubscription,
  setSubscriptionChecked,
  setHasUsedFreeTrial,
} = userSlice.actions;
export default userSlice.reducer;
